module.exports = __webpack_public_path__ + "static/img/sign-detail-bg.01b8fd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/welfare/sign-detail-bg.png
// module id = Zc70
// module chunks = 216